import { render, staticRenderFns } from "./recognizePhotoView1.vue?vue&type=template&id=41d02068&scoped=true&"
import script from "./recognizePhotoView1.vue?vue&type=script&lang=js&"
export * from "./recognizePhotoView1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d02068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\recognizePhotoPlugin\\recognize-photo-plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d02068')) {
      api.createRecord('41d02068', component.options)
    } else {
      api.reload('41d02068', component.options)
    }
    module.hot.accept("./recognizePhotoView1.vue?vue&type=template&id=41d02068&scoped=true&", function () {
      api.rerender('41d02068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recognizePhotoView1.vue"
export default component.exports